export const homeObj_1 = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Livro',
  headLine: 'Estupro de Vulnerável e Estupro Qualificado pela Idade da Vítima:',
  description: 'Evolução Legislativa e Lei Penal no Tempo',
  buttonLabel: 'Comprar',
  imgStart: '',
  img: 'images/VN-book-1.png',
  alt: 'livro',
  goTo: "https://editoracrv.com.br/produtos/detalhes/35294-estupro-de-vulneravel-e-estupro-qualificado-pela-idade-da-vitima-brevolucao-legislativa-e-lei-penal-no-tempo",
}

export const homeObj_2 = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'A autora',
  headLine: 'Viviane Macedo Sousa Nogueira',
  description: 'Graduada em Direito pela Universidade Federal do Amazonas-UFAM, pós-graduada em Direito Processual Penal pela Universidade Anhanguera-Uniderp, servidora pública do Tribunal de Justiça do Amazonas-TJAM, lotada junto à Assessoria da 2ª Vara Especializada em Crimes Contra a Dignidade Sexual de Crianças e Adolescentes. Entre em contato com a autora pelo e-mail vivianemacedo_@hotmail.com',
  buttonLabel: 'vivianemacedo_@hotmail.com',
  imgStart: 'start',
  img: 'images/author-circle.png',
  alt: 'Viviane Nogueira',
  goTo: "mailto:vivianemacedo_@hotmail.com",
}


export const homeObj_3 = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Opiniões',
  headLine: '"Certamente, esta publicação será extremamente útil para os estudantes e demais profissionais da área jurídica."',
  description: 'Articlina Guimarães, Juíza de Direito titular da 2ª Vara Especializada em Crimes Contra a Dignidade Sexual de Crianças e Adolescentes do Tribunal de Justiça do Amazonas-TJAM',
  buttonLabel: 'Comprar agora mesmo',
  imgStart: 'start',
  img: 'images/articlina-circle.png',
  alt: 'Articlina Guimarães',
  goTo: "https://editoracrv.com.br/produtos/detalhes/35294-estupro-de-vulneravel-e-estupro-qualificado-pela-idade-da-vitima-brevolucao-legislativa-e-lei-penal-no-tempo",
}





